<template>
  <layout-default>
    <span slot="title">404!</span>
    <div class="error">
      The requested page isn't in existence.
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "@/components/layouts/LayoutDefault.vue";

export default {
  name: "NotFound",
  components: {
    LayoutDefault
  }
};
</script>
